/**
 * IAiAgentProvider — public API of the AI agent facade.
 *
 * Components depend on this interface, not the concrete implementation,
 * enabling easy mocking for tests and Storybook.
 */
import { Observable } from 'rxjs';

import { AiAgentJobRequest } from '../interfaces/ai-agent-job-request.interface';
import { AiAgentSession } from '../interfaces/ai-agent-session.interface';
import { AiAgentStatus } from '../interfaces/ai-agent-status.enum';
import { AiJobProgressEvent } from '../interfaces/ai-agent-progress-event.interface';
import { AiBackendError } from '../interfaces/ai-backend-error';

export interface IAiAgentProvider {
    // ── Dispatch actions ──
    submitJob(request: AiAgentJobRequest): void;
    pollSession(sessionId: string): void;
    sendChat(sessionId: string, message: string, sectionKey?: string): void;
    connectSocket(token: string): void;
    disconnectSocket(): void;
    resetSession(): void;

    // ── Select state ──
    activeSessionId$: Observable<string | null>;
    session$: Observable<AiAgentSession | null>;
    status$: Observable<AiAgentStatus | null>;
    progressEvents$: Observable<AiJobProgressEvent[]>;
    output$: Observable<Record<string, unknown> | null>;
    isSubmitting$: Observable<boolean>;
    /** Typed backend error — translate via `error.messageKey | i18next: error.params`. */
    error$: Observable<AiBackendError | null>;
    socketConnected$: Observable<boolean>;
}
